<template>
    <div class="container">
        <div class="header" v-if="!phone">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
            </div>
            <div class="header-right">
                <el-input v-model="filterParams.admin_name" placeholder="代卖人" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.log_memo" placeholder="客户信息" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_name" placeholder="钱币名称" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_prize_min" placeholder="价格下限" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-input v-model="filterParams.product_prize_max" placeholder="价格上限" class="header-input"
                    @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column label="序号" width="100">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="logMemo" label="客户信息"></el-table-column>
            <el-table-column label="创建时间" width="200">
                <template slot-scope="scope">
                    {{ convertToDate(scope.row.logDate) }}
                </template>
            </el-table-column>
            <el-table-column label="钱币名称" sortable prop="productName" width="320">
                <template slot-scope="scope">
                    <el-popover placement="top-start" trigger="hover">
                        <el-image style="width: 300px; height: 300px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover"></el-image>
                        <el-button type="text" slot="reference">{{ scope.row.productName }}</el-button>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="adminName" label="代卖人" sortable width="150"></el-table-column>
            <el-table-column prop="productPrize" label="钱币价格" sortable width="110"></el-table-column>
            <el-table-column prop="productImages" label="钱币底图" width="85">
                <template slot-scope="scope">
                    <div style="position: relative; width: 50px; height: 50px;">
                        <el-image style="width: 50px; height: 50px;" :src="getFirstImageSrc(scope.row.productImages)"
                            fit="cover" :preview-src-list="getImageSrcList(scope.row.productImages)"></el-image>
                        <div v-if="scope.row.productImages.split(',').length > 1"
                            style="position: absolute; background-color: #FF0000; top: 0px; right: 0px; z-index: 99; width: 16px; height: 16px; line-height: 16px; text-align: center; color: #FFFFFF; font-size: 10px; border-radius: 50%;">
                            {{ scope.row.productImages.split(",").length }}</div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 100, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"

export default {
    mixins: [verifyMixin, listMixin, imageMixin, enumMixin],
    props: {
        phone: {
            type: String,
            default: ""
        },
    },
    data: function () {
        return {
        }
    },
    methods: {

    },
    created: async function () {
        this.tag = "LOGMEMO";
    },
    watch: {
        phone: {
            handler(val) {
                this.filterParams.log_memo = val;
                this.loadData(1);
            },
            immediate: true
        }
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
@import "@/assets/style/upload-style.less";
</style>